<template>
    <!-- 撤单 -->
    <common-modal :isShowClose="isShowClose">
        <div class='rescind-wrap'>
            <h1>您确定要撤单么？</h1>
            <p class="rescind-tips">您的订单在五天处理期限内，现在撤单，根据<span @click='showAgreeMent'>《下单协议》</span>须扣除订单金额50%违约金哦，您确定么？</p>
            <div class="btn-wrap">
                <div class="cancel" @click='close'>取消</div>
                <div class="submit" @click='submit'>确定</div>
            </div>
        </div>
    </common-modal>
</template>

<script>
    import commonModal from '@/components/commonModal.vue';
    import {operateOrder} from '@/api/order.js';
export default {
    props:{
        isShowClose:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return{
            order_uuid:this.$route.query.order_uuid,
			clickOperate:true			//是否可以操作弹框
        } 
    },

    methods: {
        close(){
            this.$emit("close")
        },
        
        async submit(){
			if(!this.clickOperate) {
				window.toast("请勿重复点击","txt");
				return;
			}
			this.clickOperate = false;
			setTimeout(()=>{
				this.clickOperate = true;
			},2000)
            let parmas ={type:"5"}
            const { data, status } = await operateOrder(this.order_uuid,parmas);
            if (status !== 200) return;
            this.$emit("close")
            this.$emit("showRefund")
        },
        
        showAgreeMent(){
            this.$emit("showAgreeMent")
        }
    },
    
    components:{
        commonModal
    }
 } 
</script>

<style lang="scss" scoped>
    //撤单弹框
    .rescind-wrap{
        padding: 30px;
        h1{
            text-align: center;
            font-size: 18px;
        }
        .rescind-tips{
            margin: 30px 0;
            line-height: 28px;
            span{
               @include cursor-style; 
               color: #4184F4;
            }
        }  
        //弹框按钮
        .btn-wrap{
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            .submit{
                @include cursor-style;
                width: 80px;
                height: 36px;
                line-height: 36px;
                box-sizing: border-box;
                text-align: center;
                background: #FF8E1C;
                box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
                border-radius: 5px;
                font-size: 15px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
            .cancel{
                @include cursor-style;
                @extend .submit;
                font-weight: 400;
                background: #FFFFFF;
                border: 1px solid #9A9A9A;
                color: #9A9A9A;
                margin-right: 20px;
            }
            
        }
    }
</style>
